export default {"src":"/_next/static/media/logo-with-text-white.b1ca2cfd.svg","height":128,"width":449};